export const AuditScoreBadge = ({audit}: {audit: unknown}) => {
  // @ts-expect-error legacy
  const score = audit.score;
  // @ts-expect-error legacy
  const scoreDisplayMode = audit.scoreDisplayMode || "numeric";

  let cls = "",
    label = "n/a";

  if (scoreDisplayMode === "numeric" || scoreDisplayMode === "metricSavings") {
    if (score <= 0.49) {
      label = "Poor";
      cls = "score-bad";
    } else if (score <= 0.89) {
      label = "Med";
      cls = "score-med";
    } else {
      label = "Good";
      cls = "score-good";
    }
  } else if (scoreDisplayMode === "binary") {
    if (score) {
      label = "Passed";
      cls = "score-good";
    } else {
      label = "Failed";
      cls = "score-bad";
    }
  }
  return <span className={`score-badge ${cls}`}>{label}</span>;
};
